import React, { useEffect, useState } from "react";
import SingleHotelCard from "../components/SingleHotelCard";
import AdminPanelGeneralHeading from "../components/AdminPanelGeneralHeading";
import SuccessAlert from "../components/SuccessAlert";
import ErrorAlert from "../components/ErrorAlert";
import NothingToShow from "../../components/NothingToShow";

export default function Hotels() {
  // State Handling
  const [hotelsData, setHotelsData] = useState({
    hotel_img: "",
    hotel_name: "",
    hotel_location: "",
    hotel_city: "",
    hotel_country: "",
    hotel_complete_location: "",
    hotel_number: "",
    hotel_rating: "",
    hotel_rating_review: "",
    hotel_per_day_price: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [fetchedData, setFetchedData] = useState([]);
  const [placesData, setPlacesData] = useState();
  const [countries, setCountries] = useState();
  const [loading, setLoading] = useState(false);

  // --------- Reading/Fetching Hotels From Database ---------
  const readingData = async () => {
    const response = await fetch(
      "https://hotelbnb-backend.onrender.com/read-hotels"
    );
    const result = await response.json();

    if (!response.ok) {
      setSuccess("");
      setError("Hotels can't be fetched");
    } else if (response.ok) {
      setTimeout(() => {
        setError("");
      }, 10000);
      setFetchedData(result);
    }
  };

  // --------- Reading/Fetching Places From Database ---------
  const readingPlaces = async () => {
    const response = await fetch(
      "https://hotelbnb-backend.onrender.com/read-places"
    );
    const result = await response.json();

    if (!response.ok) {
      setSuccess("");
      setError("Places can't be fetched");
    } else if (response.ok) {
      setTimeout(() => {
        setError("");
      }, 10000);
      setPlacesData(result);
      const filteringCountries = Array.from(
        new Set(
          result.map((place) => {
            return place.place_country;
          })
        )
      );
      setCountries(filteringCountries);
    }
  };

  useEffect(() => {
    readingPlaces();
    readingData();
  }, []);

  useEffect(() => {
    setHotelsData({
      ...hotelsData,
      hotel_complete_location: `${hotelsData.hotel_location}, ${hotelsData.hotel_city}, ${hotelsData.hotel_country}`,
    });
  }, [
    hotelsData.hotel_location,
    hotelsData.hotel_city,
    hotelsData.hotel_country,
  ]);

  // --------- Creating ---------
  // Upload Image Handling
  const hotelImgHandler = (e) => {
    const imgFile = e.target.files[0];
    if (imgFile) {
      const imgReader = new FileReader();
      imgReader.readAsDataURL(imgFile);
      imgReader.onloadend = () => {
        setHotelsData({
          ...hotelsData,
          hotel_img: imgReader.result,
        });
      };
      imgReader.onerror = (error) => {
        console.log(error);
      };
    }
  };

  // Form Submission To Add Hotel In DataBase
  const hotelsSubmitHandler = async (e) => {
    window.scrollTo(0, 0);
    e.preventDefault();
    setLoading(true);

    try {
      // Sending Data to Database
      const response = await fetch(
        "https://hotelbnb-backend.onrender.com/add-hotels-toDb",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(hotelsData),
        }
      );

      // Checking Response and setting success or error messages
      if (!response.ok) {
        setSuccess("");

        if (response.status === 413) {
          setError("Image is too big, Max Image Size = 1mb");
        } else {
          setError("Error Occurred, Something went wrong");
        }
      } else {
        setError("");
        setSuccess("Hotel Added Successfully");

        setTimeout(() => {
          setSuccess("");
        }, 2000);

        // Clearing The Form
        setHotelsData({
          hotel_img: "",
          hotel_name: "",
          hotel_location: "",
          hotel_city: "",
          hotel_country: "",
          hotel_number: "",
          hotel_rating: "",
          hotel_rating_review: "",
          hotel_per_day_price: "",
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }

    // Reading the Hotels again so that it shows the newly added hotel as well
    readingData();
  };

  // --------- Deleting ---------
  const deleteHandler = async (hotelId) => {
    const response = await fetch(
      `https://hotelbnb-backend.onrender.com/delete-hotel/${hotelId}`,
      {
        method: "DELETE",
      }
    );

    const result = await response.json();

    if (!response.ok) {
      setSuccess("");
      setError("Hotel can't be deleted");
    } else if (response.ok) {
      setError("");
      setSuccess("Hotel Deleted Successfully");

      setTimeout(() => {
        setSuccess("");
      }, 2000);
    }

    // Reading the hotels again
    readingData();
  };

  if (loading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Adding Hotel</p>
      </div>
    );

  if (!loading)
    return (
      <>
        {/* Showing Alert based on http request response Start */}
        {success && <SuccessAlert successMsg={success} />}
        {error && <ErrorAlert errorMsg={error} />}
        {/* Showing Alert based on http request response End */}

        {/*  Add Hotels Heading Start */}
        <AdminPanelGeneralHeading text="Add New Hotel" />
        {/*  Add Hotels Heading End */}

        {/* Add Hotels Form Start */}
        <div className="col-12 add-places-form-cover signup-form-cover">
          <form method="post" className="p-0" onSubmit={hotelsSubmitHandler}>
            {/* Row 1 */}
            <div className="d-flex justify-content-center align-items-center">
              <div className="p-0 m-0 upload-place-hotel-pic-cover upload-profile-pic-cover d-flex justify-content-center align-items-center position-relative">
                <i className="fa-solid fa-camera"></i>
                <input
                  type="file"
                  name="hotel_img"
                  className="profile-pic-input"
                  required
                  onChange={hotelImgHandler}
                />
                {hotelsData.hotel_img ? (
                  <img
                    src={hotelsData.hotel_img}
                    alt="hotel-img"
                    className="img-fluid"
                  />
                ) : (
                  ""
                )}
              </div>
            </div>

            {/* Row 2 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="hotel_name"
                  placeholder="Hotel Name"
                  className="form-control text-capitalize"
                  required
                  value={hotelsData.hotel_name}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_name: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="hotel_location"
                  placeholder="Location w/o City & Country"
                  className="form-control text-capitalize"
                  required
                  value={hotelsData.hotel_location}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_location: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
            </div>

            {/* Row 3 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <select
                  name="hotel_city"
                  className="form-control text-capitalize"
                  required
                  value={hotelsData.hotel_city}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_city: e.target.value,
                    });
                  }}
                >
                  <option value="Select the city">Select the city</option>
                  {placesData?.map((optionVal) => {
                    return (
                      <option key={optionVal._id} value={optionVal.place_city}>
                        {optionVal.place_city}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col p-0 signup-col">
                <select
                  name="hotel_country"
                  className="form-control text-capitalize"
                  required
                  value={hotelsData.hotel_country}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_country: e.target.value,
                    });
                  }}
                >
                  <option value="Select the country">Select the country</option>
                  {countries?.map((optionVal, index) => {
                    return (
                      <option key={index} value={optionVal}>
                        {optionVal}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            {/* Row 4 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <input
                  type="number"
                  name="hotel_number"
                  placeholder="Hotel Phone"
                  className="form-control"
                  required
                  value={hotelsData.hotel_number}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_number: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="hotel_rating"
                  placeholder="Hotel Rating (0-10)"
                  className="form-control text-capitalize"
                  required
                  value={hotelsData.hotel_rating}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_rating: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
            </div>

            {/* Row 5 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="hotel_rating_review"
                  placeholder="Rating Review"
                  className="form-control text-capitalize"
                  required
                  value={hotelsData.hotel_rating_review}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_rating_review: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="number"
                  name="hotel_per_day_price"
                  placeholder="Per Day Price"
                  className="form-control"
                  required
                  value={hotelsData.hotel_per_day_price}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_per_day_price: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
            </div>

            {/* Submit Btn */}
            <button
              type="submit"
              className="btn custom-btn signup-btn rounded-pill d-block mx-auto"
            >
              Add Hotel
            </button>
          </form>
        </div>
        {/* Add Hotels Form End */}

        {/* All Hotels Heading Start */}
        <AdminPanelGeneralHeading
          text="All The Hotels"
          classes="admin-panel-all-general-heading"
        />
        {/* All Hotels Heading End */}

        {/* All Hotels Cards Start */}
        <div className="col-12 all-places-cover d-flex flex-wrap justify-content-start align-items-stretch">
          {!fetchedData.length ? <NothingToShow /> : ""}

          {fetchedData?.map((singleHotel) => {
            return (
              <SingleHotelCard
                key={singleHotel._id}
                hotelId={singleHotel._id}
                hotelImg={singleHotel.hotel_img}
                hotelName={singleHotel.hotel_name}
                hotelLocation={singleHotel.hotel_location}
                hotelCity={singleHotel.hotel_city}
                hotelCountry={singleHotel.hotel_country}
                hotelPhone={singleHotel.hotel_number}
                hotelRating={singleHotel.hotel_rating}
                hotelReview={singleHotel.hotel_rating_review}
                hotelPrice={singleHotel.hotel_per_day_price}
                deleteHandler={deleteHandler}
              />
            );
          })}
        </div>
        {/* All Hotels Cards End */}
      </>
    );
}
